var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4000 4000",
    style: {
      enableBackground: "new 0 0 4000 4000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F43737;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2000,421.7c-871.67,0-1578.3,706.63-1578.3,1578.3S1128.33,3578.3,2000,3578.3S3578.3,2871.67,3578.3,2000 S2871.67,421.7,2000,421.7z M2000,3528.61c-844.23,0-1528.61-684.38-1528.61-1528.61S1155.77,471.39,2000,471.39 S3528.61,1155.77,3528.61,2000S2844.23,3528.61,2000,3528.61z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 2000,
    cy: 2000,
    r: 1486.35
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2180.9,3909.48v0.18c0,15.95,13.85,28.37,29.71,26.66c922.53-99.18,1652.08-842.8,1729.48-1771.67 c1.3-15.65-11.02-29.08-26.72-29.08h-0.19c-13.98,0-25.56,10.74-26.73,24.67c-75.31,903.1-784.61,1626.08-1681.53,1722.57 C2191.28,3884.29,2180.9,3895.76,2180.9,3909.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3888.8,1681.33h0.02c16.77,0,29.49-15.19,26.48-31.69C3762.28,809.67,3070.26,157.74,2210.68,65.3 c-15.9-1.71-29.78,10.76-29.78,26.76v0c0,13.72,10.32,25.27,23.96,26.74c835.75,89.89,1508.6,723.72,1657.46,1540.38 C3864.66,1671.99,3875.78,1681.33,3888.8,1681.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1726.65,104.31L1726.65,104.31c0-16.51-14.74-29.16-31.05-26.6C879.9,205.85,232.33,840.51,84.93,1649.65 c-3.01,16.5,9.72,31.68,26.49,31.68h0c12.98,0,24.14-9.25,26.46-22.02C281.23,872.57,910.86,255.49,1703.98,130.89 C1717.05,128.83,1726.65,117.54,1726.65,104.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.97,2135.58L86.97,2135.58c-15.75,0-28.13,13.47-26.82,29.16 c74.79,897.04,757.79,1621.29,1635.43,1759.16c16.32,2.56,31.07-10.07,31.07-26.59v-0.01c0-13.27-9.69-24.53-22.8-26.59 C850.53,3736.59,186.48,3032.39,113.77,2160.18C112.61,2146.26,100.93,2135.58,86.97,2135.58z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1947.85,
    cy: 79.87,
    r: 44.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1948.24,
    cy: 3920.13,
    r: 44.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 83.93,
    cy: 1909.03,
    r: 44.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 3916.07,
    cy: 1906.72,
    r: 44.03
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1434.04,1140.95 2841.93,2624.63 2591.31,2859.05 1158.07,1359.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2565.96,1140.95 1158.07,2624.63 1408.69,2859.05 2841.93,1359.05  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.7e7bed48bf4e2264306a7e3033922c33.svg";
export { ForwardRef as ReactComponent };